import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle
} from 'components/ui/dialog';
import { Button } from 'components/ui/button';
import { Loader2 } from 'lucide-react';

// Reusable Dialog component defined in the same file
type CustomDialogProps = {
  isOpen: boolean;
  setIsOpen: (isOpen: boolean) => void;
  isLoading?: boolean;
  title: string;
  description: string;
  children?: React.ReactNode;
  onConfirm?: () => void;
  confirmText?: string;
  cancelText?: string;
  isConfirmDisabled?: boolean;
};

export const CustomDialog = ({
  isOpen,
  setIsOpen,
  isLoading,
  title,
  description,
  children,
  onConfirm,
  confirmText = "Confirm",
  cancelText = "Cancel",
  isConfirmDisabled = false
}: CustomDialogProps) => {
  const handleConfirm = () => {
    if (onConfirm) onConfirm();
    //setIsOpen(false);
  };

  return (
    <Dialog open={isOpen} onOpenChange={setIsOpen}>
      <DialogContent className="xs:max-w-[300px] md:max-w-[400px]">
        <DialogHeader>
          <DialogTitle>{title}</DialogTitle>
          {description && <DialogDescription>{description}</DialogDescription>}
        </DialogHeader>

        <div className="py-4">
          {children}
        </div>

        <DialogFooter className="flex flex-row justify-end space-x-2">
          <Button variant="outline" onClick={(e) => { e.stopPropagation(); setIsOpen(false); }} className='w-24 outline-none'>
            {cancelText}
          </Button>
          {onConfirm && (
            <Button onClick={(e) => { e.stopPropagation(); handleConfirm(); }} className='w-24 bg-primary' disabled={isLoading || isConfirmDisabled}>
              {isLoading && <Loader2 className="animate-spin" />}
              {!isLoading && confirmText}
            </Button>
          )}
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};